.container {
  max-width: 37rem;
}

.content {
  text-align: center;
  line-height: 2rem;

  b {
    white-space: nowrap;
  }
}
